import React from "react";

export const HomeLoading = () => {
    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center space-y-4">
            <div className="relative flex items-center justify-center">
                <div className="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>
            </div>
            <p className="text-slate-500 font-medium text-sm animate-pulse">
                Verificando credenciales...
            </p>
        </div>
    );
};